import Clarity from "@microsoft/clarity";
import { isPrerendering } from "./prerender";

const ANALYTICS_BOOTSTRAP_FLAG = "__fitlogAnalyticsBootstrapped";
const CLARITY_BOOTSTRAP_FLAG = "__fitlogClarityBootstrapped";

function getMeasurementId() {
  return process.env.REACT_APP_GA_MEASUREMENT_ID || "";
}

function getClarityProjectId() {
  return process.env.REACT_APP_CLARITY_PROJECT_ID || "";
}

function shouldLoadClientAnalytics() {
  return (
    typeof window !== "undefined" &&
    process.env.NODE_ENV === "production" &&
    !isPrerendering()
  );
}

function shouldLoadGa() {
  return shouldLoadClientAnalytics() && Boolean(getMeasurementId());
}

function shouldLoadClarity() {
  return shouldLoadClientAnalytics() && Boolean(getClarityProjectId());
}

function bootstrapAnalytics() {
  const measurementId = getMeasurementId();

  if (!measurementId || window[ANALYTICS_BOOTSTRAP_FLAG]) {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: false });
  window[ANALYTICS_BOOTSTRAP_FLAG] = true;
}

function injectAnalyticsScript() {
  const measurementId = getMeasurementId();

  if (document.querySelector(`script[data-ga-measurement-id="${measurementId}"]`)) {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  script.dataset.gaMeasurementId = measurementId;
  document.head.appendChild(script);
}

function initClarity() {
  const projectId = getClarityProjectId();

  if (!shouldLoadClarity() || window[CLARITY_BOOTSTRAP_FLAG]) {
    return;
  }

  Clarity.init(projectId);
  window[CLARITY_BOOTSTRAP_FLAG] = true;
}

export function initAnalytics() {
  initClarity();

  if (!shouldLoadGa()) {
    return;
  }
  bootstrapAnalytics();

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(injectAnalyticsScript, { timeout: 2000 });
    return;
  }

  window.setTimeout(injectAnalyticsScript, 0);
}

export function trackPageView() {
  if (!shouldLoadGa()) {
    return;
  }

  bootstrapAnalytics();

  window.gtag("event", "page_view", {
    page_location: window.location.href,
    page_path: `${window.location.pathname}${window.location.search}`,
  });
}
